import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const WorkInProgress: React.FC = () => {
  return (
    <HeaderWidget
      title='Work In Progress'
      information='This metric measures the number of tasks currently in progress that have not been completed yet.'
    >
      -
    </HeaderWidget>
  )
}

export default WorkInProgress
